import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-azul text-white relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-brand-roxo/30 blur-3xl" aria-hidden />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-rosa/20 blur-3xl" aria-hidden />

      <div className="text-center relative z-10 px-4">
        <span className="inline-block text-brand-rosa font-semibold text-sm uppercase tracking-wider mb-3">
          404
        </span>
        <h1 className="font-display text-5xl md:text-7xl font-extrabold mb-4">
          Essa página não existe.
        </h1>
        <p className="text-white/70 text-lg mb-8 max-w-md mx-auto">
          Mas a dgenny existe — e está pronta para negociar por você.
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-brand-rosa text-brand-azul font-bold rounded-full hover:brightness-105 transition shadow-lg shadow-brand-rosa/20"
        >
          Voltar para a home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
